import { useState } from 'react'
import { IconX, IconChevronDown } from '@tabler/icons-react'
import { Button } from '../button/button'
import s from './history-banner.module.scss'

export const HistoryBanner = ({ role, onCreate, onEdit, teacherId, packagesCreated, packagesAvailable }) => {
    const storageKey = `history-banner-collapsed-${role}`
    const [collapsed, setCollapsed] = useState(() => localStorage.getItem(storageKey) === 'true')

    const collapse = () => {
        localStorage.setItem(storageKey, 'true')
        setCollapsed(true)
    }
    const expand = () => {
        localStorage.setItem(storageKey, 'false')
        setCollapsed(false)
    }

    const showPackagesCounter = role === 'teacher' &&
        typeof packagesCreated === 'number' &&
        typeof packagesAvailable === 'number'

    const packagesCounter = showPackagesCounter && (
        <span className={s.counter} aria-label={`Создано ${packagesCreated} из ${packagesAvailable} пакетов`}>
            Создано пакетов: {packagesCreated}/{packagesAvailable}
        </span>
    )

    const heading = role === 'teacher'
        ? 'Создайте пакеты для ваших учеников'
        : 'Занимайтесь выгоднее с пакетами занятий'

    const buttons = role === 'teacher'
        ? (
            <div className={s.buttons}>
                <Button className={s.buttonOrange} label='Создать пакет' onClick={onCreate} />
                <Button className={s.buttonClear} label='Редактировать' onClick={onEdit} />
            </div>
        )
        : <Button label='Выбрать пакет' className={s.button} to='/teachers' />

    if (collapsed) {
        return (
            <div className={`${s.container} ${s.collapsed}`}>
                <div className={s.leftBlock}>
                    <div className={s.text}>
										{packagesCounter}
                        <h4 className={s.head}>
                            {heading}
                        </h4>
                    </div>
                </div>
                <div className={s.collapsedActions}>
                    {buttons}
                    <Button type='button' className={s.toggleButton} onClick={expand} aria-label='Развернуть'>
                        <IconChevronDown size={20} />
                    </Button>
                </div>
            </div>
        )
    }

    return (
        <div className={s.container}>
            <Button className={s.toggleButton} onClick={collapse} aria-label='Свернуть'>
                <IconX size={20} />
            </Button>
            <div className={s.leftBlock}>
                <div className={s.text}>
									{packagesCounter}
                    <h4 className={s.head}>
                        {role === 'teacher'
                            ? <>Создайте пакеты <br />для ваших учеников</>
                            : <>Занимайтесь выгоднее <br /> с пакетами занятий</>}
                    </h4>
                    <div className={s.info}>
                        {role === 'teacher'
                            ? <></>
                            // ? <>Каждый пакет — это шанс получить постоянного <br />ученика с запланированными занятиями.</>
                            : <>Покупайте занятия пакетом — получайте скидку <br /> и занимайте время в календаре преподавателя заранее. </>}
                    </div>
                </div>
                {buttons}
            </div>
            <div className={s.rightBlock}>
                <img src={process.env.REACT_APP_STORAGE_URL + 'images/history/3_blocks.webp'} alt='Блоки' className={s.blocks} />
                <img src={process.env.REACT_APP_STORAGE_URL + 'images/mascot/man-default.webp'} alt='Человечек' className={s.person} />
            </div>
        </div>
    )
}
